import { Container } from "@mui/material";
import { useSnackbarCustom } from "hooks/useSnackCustom";
import { useCallback, useState } from "react";
import { useAppSelector } from "redux/hooks";
import { ROLES } from "roles/roles";
import {
  ConfiguracoesTelas,
  ConfiguracoesTitle,
  TConfiguracoesInitialState,
} from "./Configuracoes.model";
import ConfiguracoesDefaultBody from "./ConfiguracoesDefaultBody";
import ConfigurarCobrancaTabelaDeposito from "./ConfigurarCobrancaTabelaDeposito";
import ConfigurarDescontosAcrescimos from "./ConfigurarDescontosAcrescimos";
import ConfigurarMovimentacaoFiscal from "./ConfigurarMovimentacaoFiscal";
import ConfiguracaoCaixa from "./caixa/ConfiguracaoCaixa";
import ConfigurarPoliticaDevolucaoValePresente from "./configuracaovalepresente/ConfigurarPoliticaDevolucaoValePresente";
import ConfigurarPoliticaVenda from "./politica-venda/ConfigurarPoliticaVenda";

const initialState: TConfiguracoesInitialState = {
  telaAtiva: ConfiguracoesTelas.TELA_PRINCIPAL,
};

export type ConfiguracoesChildrenProps = {
  onGoBack: () => void;
};

const Configuracoes = () => {
  const KEY_CLOAK_ROLES: Array<string> = useAppSelector(
    (e) => e.token.KEY_CLOAK_ROLES
  );
  const userHasAcesso: boolean =
    KEY_CLOAK_ROLES.includes(ROLES.SUPER) ||
    KEY_CLOAK_ROLES.includes(ROLES.ADMIN);
  const { addError } = useSnackbarCustom();
  const [stateLocal, setStateLocal] = useState(initialState);

  const getScreenTitle = useCallback((screen: ConfiguracoesTelas) => {
    switch (screen) {
      case ConfiguracoesTelas.CONFIGURAR_DESCONTOS_ACRESCIMOS:
        return ConfiguracoesTitle.DESCONTOS_ACRESCIMOS;
      case ConfiguracoesTelas.CONFIGURAR_MOVIMENTACOES_FISCAIS:
        return ConfiguracoesTitle.MOVIMENTACOES_FISCAIS;
      case ConfiguracoesTelas.CONFIGURAR_COBRANCA_TABELAS_PRECO_E_DEPOSITO:
        return ConfiguracoesTitle.COBRANCA_TABELAS_PRECO_E_DEPOSITO;
      case ConfiguracoesTelas.CONFIGURAR_POLITICA_DEVOLUCAO:
        return ConfiguracoesTitle.POLITICA_DEVOLUCAO;
      case ConfiguracoesTelas.CONFIGURAR_POLITICA_VENDA:
        return ConfiguracoesTitle.CONFIGURACAO_POLITICA_VENDA;
      case ConfiguracoesTelas.CONFIGURAR_CAIXA:
        return ConfiguracoesTitle.CONFIGURACAO_CAIXA;
    }
  }, []);

  const handleNavigation = useCallback(
    (screen: ConfiguracoesTelas, enabled: boolean) => {
      if (enabled && userHasAcesso) {
        return setStateLocal((prevState) => ({
          ...prevState,
          telaAtiva: screen,
        }));
      }
      return addError({
        message: `Usuário não possui acesso para ${getScreenTitle(screen)}`,
        closeable: true,
        preventDuplicate: true,
        id: `error_screen_${getScreenTitle(screen)}`,
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  const goBack = useCallback(() => {
    setStateLocal((prevState) => ({
      ...prevState,
      telaAtiva: ConfiguracoesTelas.TELA_PRINCIPAL,
    }));
    //eslint-disable-next-line
  }, []);

  return (
    <Container
      maxWidth="xl"
      id="configuracoes-container"
      sx={{ width: "100vw", height: "calc(100vh - 84px)" }}
    >
      {stateLocal.telaAtiva === ConfiguracoesTelas.TELA_PRINCIPAL && (
        <ConfiguracoesDefaultBody
          handleActiveScreen={handleNavigation}
          hasAcesso={userHasAcesso}
        />
      )}

      {stateLocal.telaAtiva === ConfiguracoesTelas.CONFIGURAR_DESCONTOS_ACRESCIMOS && (
        <ConfigurarDescontosAcrescimos onGoBack={goBack} />
      )}

      {stateLocal.telaAtiva ===
        ConfiguracoesTelas.CONFIGURAR_MOVIMENTACOES_FISCAIS && (
          <ConfigurarMovimentacaoFiscal onGoBack={goBack} />
        )}

      {stateLocal.telaAtiva ===
        ConfiguracoesTelas.CONFIGURAR_COBRANCA_TABELAS_PRECO_E_DEPOSITO && (
          <ConfigurarCobrancaTabelaDeposito onGoBack={goBack} />
        )}

      {stateLocal.telaAtiva ===
        ConfiguracoesTelas.CONFIGURAR_POLITICA_DEVOLUCAO && (
          <ConfigurarPoliticaDevolucaoValePresente onGoBack={goBack} />
        )}

      {stateLocal.telaAtiva ===
        ConfiguracoesTelas.CONFIGURAR_POLITICA_VENDA && (
          <ConfigurarPoliticaVenda onGoBack={goBack} />
        )}

      {stateLocal.telaAtiva === ConfiguracoesTelas.CONFIGURAR_CAIXA && (
        <ConfiguracaoCaixa onGoBack={goBack} />
      )}
    </Container>
  );
};

export default Configuracoes;
